import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { actionsActions } from '../../../application/actions/actions';
import { appActions } from '../../../application/actions/aplication'


import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// ACTIONS
export function* actionsGetAllFetch(e) {
    yield put(appActions.conexionApp({ connection: true }))
    yield put(actionsActions.conexionActions({connection:true}));
    try {
        const url = `actions`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(actionsActions.createActions({data}));
    } catch (err) {
        yield put(actionsActions.errorActions({error:true, message:err.message}));
    } finally {
        yield put(actionsActions.conexionActions({connection:false}));
        yield put(appActions.conexionApp({ connection: false }))
    }
}

export function* watchFetchSesion() {
    yield takeLatest(actionsActionsSaga.actionsGetAll.type,  actionsGetAllFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const actionsGetAll = createAction('actionsSaga/actionsGetAll');

export const actionsActionsSaga = {
    actionsGetAll,
};
